var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkoda({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Skoda_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 39.9",
    style: {
      enableBackground: "new 0 0 283.5 39.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#0E3A2F;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,39.8l5.2-8.4h30.5c1.7,0,2.8-1.1,2.8-2.9v-4.9H12.4c-7.8,0-11.2-3.5-11.2-11.1V9.2c0-5.7,3.4-9.1,8.7-9.1h0.6v12.3c0,1.7,1.1,2.9,2.9,2.9h25.4c5.8,0,9.2,3.5,9.2,9.1v4.4c0,7.4-3.7,11.1-11.2,11.1L0,39.8L0,39.8z M182.5,31.2h23.6c3.9,0,6.4-2.4,6.4-6.1V14.8c0-3.8-2.5-6.2-6.4-6.2h-23.6V31.2z M173.1,39.8V0.1h33.2c9.9,0,15.6,5.7,15.6,15.1v9.4c0,9.5-5.7,15.2-15.6,15.2H173.1z M127.3,31.2h19.9c3.6,0,5.9-2.2,5.9-5.8v-11c0-3.5-2.3-5.8-5.9-5.8h-19.9c-3.6,0-5.9,2.2-5.9,5.8v11C121.3,29,123.7,31.2,127.3,31.2z M147.4,39.8H127c-9.6,0-15.2-5.5-15.2-14.8V14.8C111.8,5.6,117.4,0,127,0h20.3c9.6,0,15.1,5.6,15.1,14.8v10.1C162.5,34.2,157,39.8,147.4,39.8z M225.8,39.8l22.3-39.7h13.1l22.3,39.7h-10.8l-3.8-6.8h-19l-5.1-8.1l-8.4,14.9H225.8L225.8,39.8z M245,24.4h19l-9.5-16.9L245,24.4L245,24.4z M19.7,8.3l-5.4-8.2H47l-5.2,8.2H19.7z M58.3,39.8V0.1h9.5v15.4h12.5L96.5,0.1H109L88.3,19.8l21.1,20H96.1L79.9,24.1H67.7v15.7H58.3L58.3,39.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkoda);
export default __webpack_public_path__ + "static/media/skoda.f95e4f2fe58bd31470dcfb10570e1a3b.svg";
export { ForwardRef as ReactComponent };